var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUrgentPriority = function SvgUrgentPriority(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4.667,
    x: 3,
    y: 12.334,
    fill: "#FD3838",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 9.333,
    x: 8,
    y: 7.667,
    fill: "#FD3838",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 14,
    x: 13,
    y: 3,
    fill: "#FD3838",
    rx: 1
  })));
};
export { SvgUrgentPriority as ReactComponent };
export default __webpack_public_path__ + "6c11087948914ea886011a60fde47eae.svg";